import {HttpClient} from "../../service/httpClient/HttpClient";

export class CashGroupService {
    constructor(fundId) {
        this.fundId = fundId
        this.httpClient = new HttpClient()
    }

    getCashGroupsList(fundId, page,size, groupName = "", groupID = "") {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundId}/groups`,
                {
                    size: size,
                    page: page,
                    name: groupName,
                    "groupCode": groupID
                }
            ).then(response => resolve(response))
                .catch(reason => reject(reason))
        })
    }
}